import { withChartLayout } from 'components/common';
import ProgressNotes from 'components/features/chart/provider-chart/progress-notes/ProgressNotes';

const ProgressNotesPage = withChartLayout('Progress Notes')(ProgressNotes);
export default ProgressNotesPage;
